(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionCheckoutStep2Payment", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/subscriptionCheckoutStep2PaymentView.html",
            controller: ["subscriptionCheckoutService", "subscriptionResource", "messageService", "$state", "$translate", SubscriptionCheckoutStep2PaymentCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCheckoutStep2PaymentCtrl(subscriptionCheckoutService, subscriptionResource, messageService, $state, $translate) {
            var vm = this;
            vm.loading = true;
            if ($state.params.token !== undefined) {
                subscriptionCheckoutService.start();
            }
            vm.model = subscriptionCheckoutService.model;
            if (!subscriptionCheckoutService.wizard.isStep1Valid) {
                $state.go("main.settings.subscription");
            }
            else {
                var bindingModel = {
                    billingAddress: subscriptionCheckoutService.model.billingAddress,
                    subscriptionTypeId: subscriptionCheckoutService.model.subscriptionTypeId,
                    userCount: subscriptionCheckoutService.model.userCount,
                    displayCurrency: subscriptionCheckoutService.model.dCurrency.code
                };
                subscriptionResource.calculateSubscriptionTaxes(bindingModel, function (result) {
                    //vm.nonConvertedModel.details = result;
                    vm.model.details = result;
                    initStep2();
                }, function (error) {
                    messageService.error(error);
                    $state.go("main.settings.subscription");
                });
            }
            function initStep2() {
                subscriptionCheckoutService.setStep(2);
                vm.loading = false;
                vm.pay = function () {
                    vm.lockPaymentButtons = true;
                    var noFee = vm.model.details.annualFee ? "" : "NoFee";
                    var payModel = {
                        guid: vm.model.details.orderGuid,
                        itemDescription: $translate.instant("settings.subscription.checkout." + vm.model.details.subscriptionTypeName + ".itemDescription" + noFee, { userCount: vm.model.details.items[0].quantity })
                    };
                    if (vm.model.details.subscriptionTypeName === "Monthly") {
                        payModel.billingAgreementDescription = $translate.instant("settings.subscription.checkout.Monthly.billingAgreementDescription", { userCount: vm.model.details.items[0].quantity });
                    }
                    subscriptionResource.pay(payModel, function (result) {
                        switch (result.type) {
                            case "REDIRECT":
                                subscriptionCheckoutService.save();
                                window.open(result.redirectUrl, result.redirectTarget);
                                break;
                            case "SUCCESS":
                                vm.lockPaymentButtons = false;
                                subscriptionCheckoutService.wizard.isStep3Valid = true;
                                $state.go("main.settings.subscriptionCheckout.step3", {}, { location: "replace" });
                                break;
                            case "FAILURE":
                                messageService.error(result.errorMessage);
                                vm.lockPaymentButtons = false;
                                break;
                        }
                    }, function (error) {
                        messageService.error(error);
                        vm.lockPaymentButtons = false;
                    });
                };
            }
        }
    });
}());
